import { __rest } from '../../_virtual/_tslib.js';
import { SectionPresentation, SubsectionPresentation, SectionContentPresentation } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated */

var Looks;

(function (Looks) {
  Looks["MARKETING"] = "marketing";
  Looks["TECHNICAL"] = "technical";
})(Looks || (Looks = {}));

var defaultProps = {
  look: "marketing"
};

var Section = function Section(_a) {
  var separatorBottom = _a.separatorBottom,
      props = __rest(_a, ["separatorBottom"]);

  return /*#__PURE__*/createElement(SectionPresentation, Object.assign({}, props, {
    separator: separatorBottom
  }));
};

Section.SubSection = function (_a) {
  var separatorBottom = _a.separatorBottom,
      props = __rest(_a, ["separatorBottom"]);

  return /*#__PURE__*/createElement(SubsectionPresentation, Object.assign({}, props, {
    separator: separatorBottom
  }));
};

Section.Content = function (props) {
  return /*#__PURE__*/createElement(SectionContentPresentation, Object.assign({}, props));
};

Section.Looks = Looks;
Section.defaultProps = defaultProps;
Section.displayName = "Section";
Section.SubSection.displayName = "Section.SubSection";
Section.Content.displayName = "Section.Content";

export { Looks, Section };
